export enum ACCOUNT_ERROR {
  getAccountsData = 'Error getting accounts from DB',
  insertAccountsData = 'Error inserting accounts on DB',
}
  